import * as React from 'react'
import styled from 'styled-components'

const PreviewSvg = styled.svg`
  > .fill-neutral-seven {
    fill: ${(props) => props.theme.palette.neutral.default.seven};
  }

  > .fill-neutral-five {
    fill: ${(props) => props.theme.palette.neutral.default.five};
  }

  > .stroke-primary {
    stroke: ${(props) => props.theme.palette.brand.primary.normal};
  }

  > .fill-primary {
    fill: ${(props) => props.theme.palette.brand.primary.normal};
  }
`

interface Props extends React.SVGAttributes<SVGElement> {}

function ItineraryPreview(props: Props) {
  return (
    <PreviewSvg
      {...props}
      width="135"
      height="132"
      viewBox="0 0 135 132"
      fill="none"
    >
      <rect
        x="35"
        width="100"
        height="36"
        rx="8"
        className="fill-neutral-seven"
      />
      <rect
        x="43"
        y="8"
        width="46"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <rect
        x="43"
        y="22"
        width="84"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <rect
        x="35"
        y="48"
        width="100"
        height="36"
        rx="8"
        className="fill-neutral-seven"
      />
      <rect
        x="43"
        y="56"
        width="46"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <rect
        x="43"
        y="70"
        width="84"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <rect
        x="35"
        y="96"
        width="100"
        height="36"
        rx="8"
        className="fill-neutral-seven"
      />
      <rect
        x="43"
        y="104"
        width="46"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <rect
        x="43"
        y="118"
        width="84"
        height="6"
        rx="3"
        className="fill-neutral-five"
      />
      <line
        className="stroke-highlight"
        x1="11.5"
        y1="32.5"
        x2="11.5"
        y2="53.5"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="1 10"
      />
      <line
        className="stroke-primary"
        x1="11.5"
        y1="85.5"
        x2="11.5"
        y2="106.5"
        strokeWidth="3"
        strokeLinecap="round"
        strokeDasharray="1 10"
      />
      <path
        className="fill-primary"
        d="M12 55.7002C7.6 55.7002 4 59.3002 4 63.7002C4 69.1002 11 75.2002 11.3 75.5002C11.7 75.8002 12.2 75.8002 12.6 75.5002C13 75.2002 20 69.1002 20 63.7002C20 59.3002 16.4 55.7002 12 55.7002ZM12 67.7002C9.8 67.7002 8 65.9002 8 63.7002C8 61.5002 9.8 59.7002 12 59.7002C14.2 59.7002 16 61.5002 16 63.7002C16 65.9002 14.2 67.7002 12 67.7002Z"
      />
      <path
        className="fill-primary"
        d="M12 7.7002C7.6 7.7002 4 11.3002 4 15.7002C4 21.1002 11 27.2002 11.3 27.5002C11.7 27.8002 12.2 27.8002 12.6 27.5002C13 27.2002 20 21.1002 20 15.7002C20 11.3002 16.4 7.7002 12 7.7002ZM12 19.7002C9.8 19.7002 8 17.9002 8 15.7002C8 13.5002 9.8 11.7002 12 11.7002C14.2 11.7002 16 13.5002 16 15.7002C16 17.9002 14.2 19.7002 12 19.7002Z"
      />
      <path
        className="fill-primary"
        d="M12 103.7C7.6 103.7 4 107.3 4 111.7C4 117.1 11 123.2 11.3 123.5C11.7 123.8 12.2 123.8 12.6 123.5C13 123.2 20 117.1 20 111.7C20 107.3 16.4 103.7 12 103.7ZM12 115.7C9.8 115.7 8 113.9 8 111.7C8 109.5 9.8 107.7 12 107.7C14.2 107.7 16 109.5 16 111.7C16 113.9 14.2 115.7 12 115.7Z"
      />
    </PreviewSvg>
  )
}

export default ItineraryPreview
